import { authCookies } from "@/services/cookies";
import { Repo } from "@/store/admin/repo";

export default function isStudent({ next }) {
  const user = authCookies.getUser() || {};
  if (user.portal !== "student") {
    return next({ name: "Dashboard" });
  }
  if (Object.keys(user).length) {
    Repo.user = user;
  }
  return next();
}
